import { render, staticRenderFns } from "./GroupManager.vue?vue&type=template&id=c754371c"
import script from "./GroupManager.vue?vue&type=script&lang=js"
export * from "./GroupManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports